// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import React from 'react';
import { EventTop } from '@dip/helsecore/src/components/parts/EventTop/EventTop';
import type { EventTopProps } from '@dip/helsecore/src/components/parts/EventTop/EventTop.d';

export default (props: Readonly<EventTopProps>) => <EventTop {...props} />
